module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/Juvie-Classroom_BW-75ba406e6cf9b1bc9fedc9e9ddd7ee86.jpg";